<template>
  <div>
    <div v-for="typeOfCookies in content.typeOfCookies"
         v-bind:key="typeOfCookies._id">
      <hr>
      <b-row>
        <span class="cs-cookie-learn-more-title">{{typeOfCookies.title}}</span>
      </b-row>
      <b-row>
        <b-col>{{typeOfCookies.description}}</b-col>
        <b-col cols="3">
          <div v-if="!typeOfCookies.optional">
            <span class="cs-cookie-learn-more-title cs-cookie-always-active-desc">
              {{typeOfCookies.message}}
            </span>
          </div>
          <div v-else>
            <b-button :variant="getConsentVariant(typeOfCookies.id, true)"
                      @click="changePermissions(typeOfCookies, false)"
                      size="sm"
                      class="mr-1">
              {{typeOfCookies.rejectBtn}}
            </b-button>
            <b-button :variant="getConsentVariant(typeOfCookies.id, false)"
                      @click="changePermissions(typeOfCookies, true)"
                      size="sm">
              {{ typeOfCookies.acceptBtn }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'LearnMoreSection',
  props: {
    content: Object,
    analytics: Boolean,
  },
  methods: {
    getConsentVariant(btnId, isReject) {
      let variant;
      if (btnId === 'analytical') {
        if (isReject) {
          variant = this.analytics ? 'outline-danger' : 'danger';
        } else {
          variant = this.analytics ? 'success' : 'outline-success';
        }
      }
      return variant;
    },
    changePermissions(typeOfCookie, value) {
      if (typeOfCookie.id === 'analytical') {
        this.$emit('updateAnalytical', value);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.cs-cookie-always-active-desc {
  color: $positiveColor;
}

.cs-cookie-learn-more-title {
  font-size: $brandCookiePolicySubTitleFontSize;
  font-weight: bold;
}
</style>
